import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import Navbar from '../Layout/Navbar';
import Footer from '../Layout/Footer';
import './HomePage.css';
import Officeimg from './../Pages/Services/office.png';
import MoveInImg from './../Pages/Services/moveinout.png';
import Privatimg from './../Pages/Services/privat.png';


const HomePage = () => {
  const { t } = useLanguage();

  return (
    <div className="homepage">
      <Navbar />

      <section className="hero">
        <div className="container">
          <h1>{t('home.heroTitle', 'Professional Cleaning Services')}</h1>
          <p>{t('home.heroSubtitle', 'Your trusted partner for quality cleaning solutions')}</p>
        </div>
      </section>


      <section className="services-description">
        <div className="container">
          <h2>{t('home.servicesTitle', 'Our Cleaning Services')}</h2>
          <p className="services-intro">
            {t('home.servicesIntro', 'We provide professional cleaning solutions tailored to meet your specific needs. Whether you need regular maintenance for your home, comprehensive cleaning for your business, or specialized move-in/move-out services, our experienced team is here to help. We use eco-friendly products and proven techniques to ensure your space is not just clean, but truly spotless.')}
          </p>
        </div>
      </section>

      <section className="services">
        <div className="container">
          <h2>{t('home.whatWeOffer', 'What We Offer')}</h2>
          <div className="services-grid">
            <Link to="/services/private-cleaning" className="service-card-link">
              <div className="service-card">
                <div className="service-image">
                  <img src={Privatimg} alt="Private Cleaning" />
                </div>
                <h3>{t('home.privateCleaning', 'Private Cleaning')}</h3>
                <p>{t('home.privateCleaningDesc', 'Professional residential cleaning services to keep your home spotless and comfortable.')}</p>
              </div>
            </Link>
            <Link to="/services/commercial-cleaning" className="service-card-link">
              <div className="service-card">
                <div className="service-image">
                  <img src={Officeimg} alt="Commercial Cleaning" />
                </div>
                <h3>{t('home.commercialCleaning', 'Commercial Cleaning')}</h3>
                <p>{t('home.commercialCleaningDesc', 'Comprehensive office and business cleaning solutions to maintain a professional workspace.')}</p>
              </div>
            </Link>
            <Link to="/services/move-in-move-out" className="service-card-link">
              <div className="service-card">
                <div className="service-image">
                  <img src={MoveInImg} alt="Move-in/Move-out Cleaning" />
                </div>
                <h3>{t('home.moveInMoveOut', 'Move-in/Move-out Cleaning')}</h3>
                <p>{t('home.moveInMoveOutDesc', 'Complete deep cleaning services for tenants and homeowners during relocation.')}</p>
              </div>
            </Link>
          </div>
      
        </div>
      </section>

      <section className="trust-section">
        <div className="container">
          <h2>{t('home.trustTitle', 'A Cleaning Service You Can Trust')}</h2>
          <div className="trust-grid">
            <div className="trust-item">
              <div className="trust-icon">✓</div>
              <h3>{t('home.verifiedCleaners', 'Verified Cleaners')}</h3>
              <p>{t('home.verifiedCleanersDesc', 'All our cleaners have background checks and verified credentials')}</p>
            </div>
            <div className="trust-item">
              <div className="trust-icon">🔒</div>
              <h3>{t('home.secureSafe', 'Secure & Safe')}</h3>
              <p>{t('home.secureSafeDesc', 'Your keys and personal information are handled with the utmost security')}</p>
            </div>
            <div className="trust-item">
              <div className="trust-icon">⭐</div>
              <h3>{t('home.qualityGuaranteed', 'Quality Guaranteed')}</h3>
              <p>{t('home.qualityGuaranteedDesc', 'We ensure high-quality service with satisfaction guaranteed')}</p>
            </div>
            <div className="trust-item">
              <div className="trust-icon">📞</div>
              <h3>{t('home.directContact', 'Direct Contact')}</h3>
              <p>{t('home.directContactDesc', 'Get direct contact with your cleaning team for better communication')}</p>
            </div>
          </div>
        </div>
      </section>



      <Footer />
    </div>
  );
};

export default HomePage;
